import React, { useContext } from 'react';
import EDRadioGroup, {
  IRadioDef,
} from '../../../../../../../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import { BusinessDataFormContext } from '../../../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';

import { FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All } from '../../../../../../Queries/_QueryTypes/FakturaDelQuery';

enum RegisteredValues {
  EJ_ANGIVET = 'EJ_ANGIVET',
  JA = 'JA',
  NEJ = 'NEJ',
}

interface IProps {
  originKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null;
  updatedKonteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All;
  konteringsforslagDisabled: boolean;
}

const RadioButtonsFI: React.FC<React.PropsWithChildren<IProps>> = props => {
  const formContext = useContext(BusinessDataFormContext);

  const radioDefsFI: IRadioDef[] = [
    {
      label: 'Ja',
      value: RegisteredValues.JA,
    },
    {
      label: 'Nej',
      value: RegisteredValues.NEJ,
    },
  ];

  return (
    <EDRadioGroup
      disabled={props.konteringsforslagDisabled}
      fullWidth
      noFocusColor
      label="Ska förbrukningsinventariet registerföras?"
      marginTop="dense"
      paddingLeft="dense"
      radioDefs={radioDefsFI}
      row
      value={props.updatedKonteringsforslag?.FI_REGISTRERAS ?? 'E'}
      onChange={(newValue: string) => {
        const registeredValue = newValue as RegisteredValues;
        if (formContext) {
          formContext.update([
            {
              operation: 'OwnFields',
              values: { FI_REGISTRERAS: registeredValue },
            },
          ]);
        }
      }}
    />
  );
};

export default RadioButtonsFI;
